import { render, staticRenderFns } from "./CheckboxWithNotes.vue?vue&type=template&id=9421433e&scoped=true&"
import script from "./CheckboxWithNotes.vue?vue&type=script&lang=js&"
export * from "./CheckboxWithNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421433e",
  null
  
)

export default component.exports